import React, { FC } from 'react';
import { FormControl, FormControlLabel, RadioGroup, Typography, Grid } from '@material-ui/core';
import { Radio as MuiRadio } from '@ccm-office/ccm-ui';
import HelpIcon from '@material-ui/icons/Help';
import { Tooltip } from '@ccm-office/ccm-ui';

import useStyles from './style';
import { IRadio } from './types';

const Radio: FC<IRadio> = ({
  disabled,
  name,
  label,
  tooltip,
  options = [],
  row = false,
  value,
  onChange = () => {},
}) => {
  const classes = useStyles();

  return (
    <FormControl data-testid={`radio-${name}`} disabled={disabled}>
      <Grid
        container
        spacing={2}
        direction={row ? 'row' : 'column'}
        alignItems={row ? 'center' : 'flex-start'}
      >
        <Grid item className={classes.radio}>
          <Typography data-testid={`radio-label-${name}`} variant="h4">
            {label}
          </Typography>
        </Grid>
        <Grid item>
          <RadioGroup name={name} value={value} onChange={onChange} row={row}>
            {options.map(({ value, label, dataTestId }, index) => {
              return (
                <FormControlLabel
                  key={index}
                  value={value}
                  control={
                    <MuiRadio
                      color="default"
                      css="none"
                      data-testid={dataTestId || `radio-value-${index}`}
                    />
                  }
                  label={label}
                />
              );
            })}
          </RadioGroup>
        </Grid>
        {tooltip && (
          <Grid item>
            <Tooltip title={tooltip}>
              <HelpIcon className={classes.helpIcon} />
            </Tooltip>
          </Grid>
        )}
      </Grid>
    </FormControl>
  );
};

export default Radio;
